import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickNav from "./components/CategoryQuickNav";
import FeaturedMovies from "./components/FeaturedMovies";
import LatestNews from "./components/LatestNews";
import SiteIntro from "./components/SiteIntro";
import { movies } from "@/mocks/movies";
import { news } from "@/mocks/news";

export default function Home() {
  const featured = movies.filter((movie) => movie.featured).slice(0, 5);
  const latestMovies = movies.slice(0, 8);
  const latestNews = news.slice(0, 6);

  return (
    <>
      <HeroCarousel movies={featured} />
      <CategoryQuickNav />
      <FeaturedMovies movies={latestMovies} />
      <LatestNews news={latestNews} />
      <SiteIntro />
    </>
  );
}